import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { CACHE_AND_STALE_TIME } from 'constants/index';
import { useQuery } from 'react-query';
import toastr from 'react-hot-toast';
import type { SinglePluginConnectionsResponse } from 'types/PluginConnections';
import {
  generateIncludeQuery,
  generateURL,
} from 'utilities/hooks/urlGeneration';
import { fetchWrapper } from 'utils/fetchWrapper';
import { filterIncludedItem } from 'utilities/hooks/responseHandlers';
import type { PluginAuthentication } from 'types/PluginAuthentications';
import type { PluginAuthenticationType } from 'types/PluginAuthenticationTypes';

const getPluginConnections = (
  pluginConnectionID: string | null | undefined
) => {
  if (!pluginConnectionID) {
    return Promise.reject('pluginConnection ID is required.');
  }

  const queryArray = [
    generateIncludeQuery(['pluginAuthentication.authenticationType']),
  ];
  const url = generateURL(
    SPARK_RESOURCE_TYPES.PLUGIN_CONNECTIONS,
    queryArray,
    pluginConnectionID
  );

  return fetchWrapper<SinglePluginConnectionsResponse>({
    url: url,
    method: 'GET',
  });
};

export const usePluginConnectionByID = (
  pluginConnectionID: string | null | undefined
) => {
  const query = useQuery(
    ['pluginConnection', pluginConnectionID],
    () => getPluginConnections(pluginConnectionID),
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`failed to Fetch Plugin connection: ${error.message}`);
        }
      },
      enabled: Boolean(pluginConnectionID),
      ...CACHE_AND_STALE_TIME,
    }
  );
  const { data } = query;
  const { data: pluginConnection, included } = data || {};

  const pluginAuthentication = filterIncludedItem<PluginAuthentication>(
    included,
    SPARK_RESOURCE_TYPES.PLUGIN_AUTHENTICATION
  );
  const pluginAuthenticationType = filterIncludedItem<PluginAuthenticationType>(
    included,
    SPARK_RESOURCE_TYPES.AUTHENTICATION_TYPE
  );

  return {
    pluginConnection,
    pluginAuthenticationType: pluginAuthenticationType?.at(0),
    pluginAuthentication,
    ...query,
  };
};
